import { Translation } from 'cng-common/features/translations'

import type { IAttentionStatusesUnit } from '../../types'

import styles from './AttentionCount.module.scss'

interface IAttentionCountProps {
  count: number
  unit: IAttentionStatusesUnit
}

/**
 * `12 partners`, `1 status` — a count and the unit's own word, singular or plural by the count.
 * The figure is ours and the word is the unit's key, so the phrase has no key of its own that a
 * translation could pin to one unit.
 */
export const AttentionCount = ({ count, unit }: IAttentionCountProps) => (
  <span>
    <span className={styles.figure}>{count}</span>{' '}
    <Translation span text={count === 1 ? unit.singularKey : unit.pluralKey} />
  </span>
)

AttentionCount.displayName = 'AttentionCount'
